import { render, staticRenderFns } from "./BusinessNameAmendmentsTaskQueue.vue?vue&type=template&id=d231c3aa&scoped=true&"
import script from "./BusinessNameAmendmentsTaskQueue.vue?vue&type=script&lang=js&"
export * from "./BusinessNameAmendmentsTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameAmendmentsTaskQueue.vue?vue&type=style&index=0&id=d231c3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d231c3aa",
  null
  
)

export default component.exports